// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CenteredLoader CSS */
.loading-text {
    color: #3498db;
    font-size: 1rem;
    position: relative; /* Position relative for animation */
    animation: loadingAnimation 2s infinite;
  }
  
  @keyframes loadingAnimation {
    0%, 100% {
      opacity: 1;
      transform: scale(1); /* Initial and final scale */
    }
    50% {
      opacity: 0.5;
      transform: scale(1.1); /* Slightly larger scale */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/AdminPages/loaderStyles.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,cAAc;IACd,eAAe;IACf,kBAAkB,EAAE,oCAAoC;IACxD,uCAAuC;EACzC;;EAEA;IACE;MACE,UAAU;MACV,mBAAmB,EAAE,4BAA4B;IACnD;IACA;MACE,YAAY;MACZ,qBAAqB,EAAE,0BAA0B;IACnD;EACF","sourcesContent":["/* CenteredLoader CSS */\n.loading-text {\n    color: #3498db;\n    font-size: 1rem;\n    position: relative; /* Position relative for animation */\n    animation: loadingAnimation 2s infinite;\n  }\n  \n  @keyframes loadingAnimation {\n    0%, 100% {\n      opacity: 1;\n      transform: scale(1); /* Initial and final scale */\n    }\n    50% {\n      opacity: 0.5;\n      transform: scale(1.1); /* Slightly larger scale */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
